import React, { useEffect, useRef, useState } from 'react'
import { ModalsType, layoutActions } from '@Techedge/digitalportal-shared'
import { connect } from 'react-redux'
import Header from '../components/Layout/Header/Header'
import { LuxBreadcrumb } from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'
import MainContent from '../components/Layout/MainContent/MainContent'
import { GlobalSearchContent } from '../components/GlobalSearch/GlobalSearchContent'
import { GlobalSearchInput, SectionType } from '../models/search'
import {
    closeGlobalSearch,
    getGlobalSearch,
    resetSearch,
} from '../redux/actions/global-search'
import { NavbarAppState } from '../redux/states/appState'
import './GlobalSearch.scss'
import { useNavigate } from 'react-router-dom'

const GlobalSearch = (props: any) => {
    const {
        closeGlobalSearch,
        globalSearch,
        searchInput,
        searchOutput,
        resetSearch,
        requesting,
        openActivity,
        onClose,
        globalFiltersList,
    } = props
    const intl = useIntl()
    const globalSearchRef: any = useRef()
    const componentClass: string = 'smart-modals-search'
    const navigate = useNavigate()
    const localStorageBreadcrumbKey = 'breadcrumbs'

    const searchBreadcrumb = {
        id: '0',
        label: intl.formatMessage({
            id: 'navbar.search.breadcrumbs.search',
            defaultMessage: 'Search',
        }),
        url: '#',
    }

    const formatSectionTitle = () => {
        return {
            id: '0',
            label: intl.formatMessage({
                id: `navbar.search.menu.${searchInput.sectionType}`,
                defaultMessage: 'Search',
            }),
            url: '#',
        }
    }

    const onListItemClick = (item: any, key: string) => {
        switch (key) {
            case SectionType.calendar:
            case SectionType.activity:
                localStorage.setItem(localStorageBreadcrumbKey, window.location.href)
                onClose()
                openActivity({ id: item.id, storeIds: item.store_ids })
                break
            case SectionType.library:
                onClose()
                let url: string = `/resources/${
                    item?.resourceType === 'folder' ? 'folder' : 'document'
                }/${item?.id}`
                navigate(url)
                break
            case SectionType.quick_link:
                window.open(item?.url, '_blank', 'noreferrer')
            default:
                break
        }
    }

    return (
        <div className="smart-modals-fullscreen">
            <div className={componentClass} data-isfullscreen={true}>
                <div className={`${componentClass}__header`}>
                    <Header
                        negative
                        onClose={() => {
                            closeGlobalSearch()
                            onClose()
                        }}
                        backIcon="undo"
                        {...(searchInput?.sectionType
                            ? {
                                  onBack: globalSearchRef.current
                                      ?.resetSectionType,
                              }
                            : null)}>
                        <LuxBreadcrumb
                            pathArray={[
                                searchInput?.sectionType
                                    ? formatSectionTitle()
                                    : searchBreadcrumb,
                            ]}
                        />
                    </Header>
                </div>
                <div className={`${componentClass}__main`}>
                    <div className={`${componentClass}__content`}>
                        <MainContent hideFooter>
                            <GlobalSearchContent
                                ref={globalSearchRef}
                                searchInput={searchInput}
                                requesting={requesting}
                                globalFiltersList={globalFiltersList}
                                onSearch={globalSearch}
                                searchOutput={searchOutput}
                                onResetSearch={resetSearch}
                                onListItemClick={onListItemClick}
                            />
                        </MainContent>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: NavbarAppState) => ({
    searchInput: state.globalSearchReducer.searchInput,
    searchOutput: state.globalSearchReducer.searchOutput,
    requesting: state.globalSearchReducer.requesting,
    globalFiltersList: state.filtersReducer.filtersList,
})

const mapDispatchToProps = (dispatch: any) => ({
    closeGlobalSearch: () => {
        dispatch(closeGlobalSearch())
    },
    resetSearch: () => dispatch(resetSearch()),
    globalSearch: (params: GlobalSearchInput | any) =>
        dispatch(getGlobalSearch(params)),
    openActivity: (activity: any) => {
        dispatch(
            layoutActions.setModals({
                type: ModalsType.TASK_EXECUTION,
                props: activity,
            })
        )
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(GlobalSearch)
